/**
 * @generated SignedSource<<cef7be4cc9cb54a56eb338c662523382>>
 * @relayHash 5d42554987a7deb7d918e30e0c782f3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ff16a4a9a4ee0c23a78cff28ab639a88978f4bf29a6d1536290b0ed4211323b

import type { ConcreteRequest } from 'relay-runtime';
export type EditorContentStateComponentRemoveContentStateAndPublishMutation$variables = {
  contentId: string;
  doPublish?: boolean | null | undefined;
  suppressDraftPropertyUpdate?: boolean | null | undefined;
};
export type EditorContentStateComponentRemoveContentStateAndPublishMutation$data = {
  readonly removeContentState: boolean | null | undefined;
};
export type EditorContentStateComponentRemoveContentStateAndPublishMutation = {
  response: EditorContentStateComponentRemoveContentStateAndPublishMutation$data;
  variables: EditorContentStateComponentRemoveContentStateAndPublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "doPublish"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suppressDraftPropertyUpdate"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "doPublish",
        "variableName": "doPublish"
      },
      {
        "kind": "Variable",
        "name": "suppressDraftPropertyUpdate",
        "variableName": "suppressDraftPropertyUpdate"
      }
    ],
    "kind": "ScalarField",
    "name": "removeContentState"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5d42554987a7deb7d918e30e0c782f3d",
    "id": "6ff16a4a9a4ee0c23a78cff28ab639a88978f4bf29a6d1536290b0ed4211323b",
    "metadata": {},
    "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
    "operationKind": "mutation",
    "text": "mutation EditorContentStateComponentRemoveContentStateAndPublishMutation($contentId:ID!,$doPublish:Boolean,$suppressDraftPropertyUpdate:Boolean){removeContentState(contentId:$contentId,doPublish:$doPublish,suppressDraftPropertyUpdate:$suppressDraftPropertyUpdate)}"
  }
};
})();

(node as any).hash = "026930d5205574a785b2cb15e054e188";

export default node;
